// Validate PAN number
export function validatePAN(pan) {
  const panRegex = /^[A-Z]{5}[0-9]{4}[A-Z]{1}$/;
  return panRegex.test(pan);
}

// Validate Aadhar number
export function validateAadhar(aadhar) {
  if (!aadhar) return false;

  // Remove any dashes or spaces the user might have typed
  const clean = aadhar.replace(/[^0-9]/g, "");

  // Must be exactly 12 digits
  if (clean.length !== 12) return false;

  // Must be digits only and not all same digit (to avoid 0000-0000-0000)
  if (!/^\d{12}$/.test(clean) || /^(\d)\1+$/.test(clean)) return false;

  return true;
}

// Validate IFSC code
export function validateIFSC(ifsc) {
  const ifscRegex = /^[A-Z]{4}0[A-Z0-9]{6}$/;
  return ifscRegex.test(ifsc);
}

// Validate TAN (10 characters, alphanumeric)
export function validateTAN(tan) {
  const regex = /^[A-Z]{4}[0-9]{5}[A-Z]$/;
  return regex.test((tan || "").toUpperCase());
}

// Validate GSTIN (15 chars with format)
export function validateGSTIN(gstin) {
  const regex = /^[0-9]{2}[A-Z]{5}[0-9]{4}[A-Z]{1}[1-9A-Z]{1}Z[0-9A-Z]{1}$/;
  return regex.test((gstin || "").toUpperCase());
}

// Validate CIN (21 characters)
export function validateCIN(cin) {
  const regex = /^[A-Z]{1}[0-9]{5}[A-Z]{2}[0-9]{4}[A-Z]{3}[0-9]{6}$/;
  return regex.test((cin || "").toUpperCase());
}

// Validate PF Registration (common pattern: MH/PF/123456 or MH/12345)
export function validatePFRegistration(pf) {
  const regex = /^[A-Z]{2}\/?[A-Z]*\/?[0-9]{3,7}$/;
  return regex.test((pf || "").toUpperCase());
}

// Validate ESI Registration (common 17-digit numeric)
export function validateESIRegistration(esi) {
  const regex = /^[0-9]{17}$/;
  return regex.test((esi || "").toUpperCase());
}

export function validateAccountNumber(accNo) {
  const regex = /^[0-9]{9,18}$/;
  return regex.test(accNo || "");
}

// Validate a contact phone number (used for the optional emergency contact).
// Accepts an optional leading +, and separators, as long as 7-15 digits remain.
// Callers decide whether a blank value is acceptable — this only checks format.
export function validateContactPhone(phone) {
  const clean = String(phone || "").replace(/[\s\-()]/g, "");
  return /^\+?[0-9]{7,15}$/.test(clean);
}
